import React, { useEffect, useState } from "react";
import WarningPopup from "../../components/common/controls/warningPopup";
import { constants } from "../../constants/constants";
import { Button, FormControl, MenuItem, TextField } from "@material-ui/core";
import { faLessThanEqual } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import MergeDDPopup from "./mergeDDPopup";

export default function ImportECATRules({
  showImportRule = false,
  setShowImportRule = () => {},
  injectIntlTranslation,
  intl,
  classes,
  setLoading = () => {},
  newConfigGroup = [],
  getDDValues,
  getConfigGroups = () => {},
  setSnackBar,
}) {
  const [formState, setFormState] = useState({
    productLine: "",
    ruleset: "",
    tag: "",
    properties: "",
    enviroment: "",
  });
  const [ruleOpen, setRuleOpen] = useState(false);
  const [rulesData, setRulesData] = useState(null);
  const [token, setToken] = useState("");

  useEffect(() => {
    setToken(localStorage.getItem("msal.idtoken"));
  }, []);

  const env = [
    {
      label: "Dev",
      url: "https://dev-rulesengine.carrier.com/api/EcatEngine/GetInitialStateWithDefaultValuesVersioned?OutputVersion=5",
    },
    {
      label: "Qa",
      url: "https://qa-rulesengine.carrier.com/api/eCatEngine/GetInitialStateWithDefaultValuesVersioned?OutputVersion=5",
    },
    {
      label: "Prod",
      url: "https://rulesengine.carrier.com/api/eCatEngine/GetInitialStateWithDefaultValuesVersioned?OutputVersion=5",
    },
  ];

  const handleMerge = async () => {
    // setShowImportRule(false);
    setLoading(true);

    const payload = {
      selectedModel: formState?.ruleset || "SEL_PCN",
      selectedProductLine: formState?.productLine,
      tags: formState?.tag
        ? formState?.tag.split(",").map((x) => x.trim())
        : null,
      targetProperties: formState?.properties.trim()
        ? formState?.properties.split(",").map((x) => x.trim())
        : null,
    };

    const [envSelected = null] = env.filter(
      (x) => x.label === formState.enviroment
    );

    const tokenTemp = token || localStorage.getItem("msal.idtoken");

    console.log("Token: ", tokenTemp);

    await axios
      .post(envSelected.url, payload, { Authorization: `Bearer ${tokenTemp}` })
      .then((res) => {
        setRulesData(res.data);
        setRuleOpen(true);
        setLoading(false);
        setShowImportRule(false);
        setFormState({
          productLine: "",
          ruleset: "",
          tag: "",
          properties: "",
          enviroment: "",
        });
      })
      .catch((err) => {
        setLoading(false);
        console.log("error: ", err);
      });
  };

  const hanldeChange = (e, id) => {
    const { value } = e.target;
    if (
      (id === "productLine" || id === "ruleset") &&
      !isValidProductLine(value) &&
      value
    ) {
      return;
    }

    if (
      value &&
      !isTagPropertiesInput(value) &&
      (id === "tag" || id === "properties")
    ) {
      return;
    }

    setFormState({ ...formState, [id]: value });
  };

  function isValidProductLine(input) {
    const regex = /^[a-zA-Z0-9_]+(?: [a-zA-Z0-9_]+)*( )?$/;
    return regex.test(input);
  }

  function isTagPropertiesInput(input) {
    const regex =
      /^(?!.*,,)(?! )[a-zA-Z0-9_]+(?: *(?:, *)? *[a-zA-Z0-9_]+)*(?: *(?:, *)?)?( )?$/;
    return regex.test(input);
  }

  return (
    <>
      <WarningPopup
        open={showImportRule}
        onClose={() => {
          setShowImportRule(false);
          setFormState({
            productLine: "",
            ruleset: "",
            tag: "",
            properties: "",
            enviroment: "",
          });
        }}
        title={injectIntlTranslation(
          intl,
          "ecatRuleImportBtn",
          constants.ecatRuleImportBtn
        )}
        description={
          <form style={{}}>
            <div style={{ gap: "20px" }}>
              <div>
                <FormControl
                  className={classes.formControlDropdown}
                  style={{ width: "100%", marginBottom: "10px" }}
                >
                  <TextField
                    id="enviroment"
                    select
                    label={injectIntlTranslation(
                      intl,
                      "enviroment",
                      constants.enviroment
                    )}
                    variant="outlined"
                    onChange={(e) => {
                      hanldeChange(e, "enviroment");
                    }}
                    style={{
                      width: "100%",
                      marginBottom: "10px",
                      height: "40px",
                    }}
                    labelId="region-name-select-required-label"
                    className="dropdown-btn-field"
                  >
                    {env.map((x) => {
                      return <MenuItem value={x.label}>{x.label}</MenuItem>;
                    })}
                  </TextField>
                </FormControl>
              </div>

              <TextField
                id="productLine"
                label={injectIntlTranslation(
                  intl,
                  "productLine",
                  constants.productLine
                )}
                value={formState.productLine}
                variant="outlined"
                onChange={(e) => hanldeChange(e, "productLine")}
                style={{ width: "100%", height: "40px", marginBottom: "20px" }}
              />
              <TextField
                id="ruleset"
                label={injectIntlTranslation(
                  intl,
                  "ruleset",
                  constants.ruleset
                )}
                variant="outlined"
                value={formState.ruleset}
                onChange={(e) => hanldeChange(e, "ruleset")}
                style={{ width: "100%", height: "40px", marginBottom: "20px" }}
              />
              <TextField
                id="tag"
                label={injectIntlTranslation(intl, "tag", constants.tag)}
                variant="outlined"
                value={formState.tag}
                onChange={(e) => hanldeChange(e, "tag")}
                style={{
                  width: "100%",
                  height: "40px",
                  marginBottom: "20px",
                  cursor: !!formState.properties.trim()
                    ? "not-allowed"
                    : "auto",
                }}
                disabled={!!formState.properties.trim()}
              />
              <TextField
                id="properties"
                label={injectIntlTranslation(
                  intl,
                  "properties",
                  constants.properties
                )}
                variant="outlined"
                value={formState.properties}
                onChange={(e) => hanldeChange(e, "properties")}
                style={{
                  width: "100%",
                  height: "40px",
                  marginBottom: "20px",
                  cursor: !!formState.tag.trim() ? "not-allowed" : "auto",
                }}
                disabled={!!formState.tag.trim()}
              />
            </div>
            <div style={{ width: "100%", textAlign: "right" }}>
              <Button
                color="primary"
                variant="contained"
                onClick={handleMerge}
                disabled={
                  !formState.productLine ||
                  // !formState.properties ||
                  // !formState.tag ||
                  !formState.ruleset ||
                  !formState.enviroment
                }
                className={classes.saveButton}
                style={{ marginLeft: "auto", marginTop: "20px" }}
              >
                {injectIntlTranslation(intl, "merge", constants.merge)}
              </Button>
            </div>
          </form>
        }
        hideBtn={true}
      />

      <WarningPopup
        open={ruleOpen && rulesData?.VariableDomains}
        onClose={() => {
          setRuleOpen(false);
        }}
        title={injectIntlTranslation(
          intl,
          "ecatRuleImportBtn",
          constants.ecatRuleImportBtn
        )}
        description={
          <MergeDDPopup
            injectIntlTranslation={injectIntlTranslation}
            intl={intl}
            data={rulesData?.VariableDomains || {}}
            newConfigGroup={newConfigGroup}
            onSuccess={() => {
              getDDValues();
              setRuleOpen(false);
            }}
            getConfigGroups={getConfigGroups}
            setSnackBar={setSnackBar}
          />
        }
        hideBtn={true}
        width={"900px"}
        marginTop={"50px"}
        isOnClose={false}
      />
    </>
  );
}
